import { render } from "./CIS-Content-Block-With-Label.vue?vue&type=template&id=c62685ba&scoped=true"
import script from "./CIS-Content-Block-With-Label.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Block-With-Label.vue?vue&type=script&lang=js"

import "./CIS-Content-Block-With-Label.vue?vue&type=style&index=0&id=c62685ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62685ba"]])

export default __exports__